import { render, staticRenderFns } from "./FromMails.create.vue?vue&type=template&id=5544a05c&"
import script from "./FromMails.create.vue?vue&type=script&lang=js&"
export * from "./FromMails.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports